<template>
  <v-card :loading="isLoading">
    <template v-slot:progress>
      <v-progress-linear absolute indeterminate color="white" />
    </template>
    <v-card-title
      class="py-0 pl-4 pr-2"
      style="background-color: #333333"
      :class="{ rounded: !isShowContent }"
    >
      <span class="subtitle-1 font-weight-bold white--text">{{ title }}</span>
      <v-spacer />
      <v-btn icon @click="isShowContent = !isShowContent">
        <v-icon color="white">{{ isShowContent ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-slide-y-transition hide-on-leave>
      <div v-show="isShowContent">
        <v-card-text v-if="!!$slots.content">
          <slot name="content"></slot>
        </v-card-text>
        <v-card-actions v-if="!!$slots.action">
          <slot name="action"></slot>
        </v-card-actions>
      </div>
    </v-slide-y-transition>
  </v-card>
</template>
<script>
export default {
  props: {
    title: String,
    isShow: Boolean,
    isLoading: Boolean,
  },
  data() {
    return {
      isShowContent: true,
    }
  },
  watch: {
    isShow(v) {
      this.isShowContent = v
    },
  },
}
</script>
